import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '@saucelabs/sl-component-grid';
import { Modal } from '@saucelabs/sl-component-overlay';
import Well from '@saucelabs/sl-component-well';
import { Button } from '@saucelabs/sl-component-buttons';
import { InExperimentTernaryContainer } from '@saucelabs/sl-container-experiment';
import { apiBaseUrls } from '@saucelabs/sl-util-config';

import Styles from './AccountExpiredModal.styles';
import { trackEvent, EVENTS } from './../../tracking';

const AccountExpiredModal = ({ show }) => {
  useEffect(() => {
    if (show) {
      trackEvent(EVENTS.ACCOUNT_EXPIRED_MODAL_SHOW);
    }
  }, [show]);

  return (
    <Modal
      dialogClassName="accountExpiredModal"
      fitWindow
      show={show}
    >
      <Modal.Header>
        <Modal.Title>Your Sauce Labs Virtual Cloud Trial has Expired</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col sm={6}>
            <div className={Styles['modal-copy']}>
              <p>
                We&lsquo;re sorry, your Sauce Labs Virtual Cloud account has expired.
                If you feel you are seeing this message in error, please contact Sauce Support,
                or your administrator.
              </p>
              <div className={Styles['buy-button-wrapper']}>
                <InExperimentTernaryContainer name="web-ui-billing">
                  <Button
                    category="action"
                    href="/billing"
                    onClick={() => {
                      trackEvent(EVENTS.ACCOUNT_EXPIRED_PAY_NOW_CLICK);
                    }}
                    size="sm"
                  >
                    Buy Now
                  </Button>
                  <Button
                    category="action"
                    href={apiBaseUrls.billing}
                    onClick={() => {
                      trackEvent(EVENTS.ACCOUNT_EXPIRED_PAY_NOW_CLICK);
                    }}
                    size="sm"
                  >
                    Buy Now
                  </Button>
                </InExperimentTernaryContainer>
              </div>
            </div>
          </Col>
          <Col sm={6}>
            <div className={Styles['well-wrapper']}>
              <Well className={Styles['pro-tip']}>
                <p><strong>Looking for Real Devices?</strong></p>
                <p>
                  If you already have a Sauce Labs Real Device Cloud account, you may access
                  your account below.
                </p>
                <a
                  href={`${apiBaseUrls.encore}/signup/test_object`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Access Real Devices
                </a>
              </Well>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};


AccountExpiredModal.propTypes = {
  show: PropTypes.bool.isRequired,
};

export default AccountExpiredModal;
export { AccountExpiredModal };
